module.exports = __webpack_public_path__ + "img/Bhutan.96d5c4a7.svg";